import { usePlatformSettingsStore, selectBranding } from '@/store/platform-settings/store';
import { useThemeStore } from '@/store/theme/store';

export default function Logo() {
  const branding = usePlatformSettingsStore(selectBranding);
  const theme = useThemeStore((state) => state.theme);

  // Determine which logo URL to use based on theme
  const getLogoUrl = (): string | null => {
    if (theme === 'dark') {
      return branding.LOGO_DARK_URL || branding.LOGO_URL || null;
    }
    return branding.LOGO_LIGHT_URL || branding.LOGO_URL || null;
  };

  const logoUrl = getLogoUrl();
  const platformName = branding.PLATFORM_NAME || '';

  // Theme-based logo selection for fallback
  const logoSrc = theme === 'dark'
    ? '/assets/images/logo.svg'
    : '/assets/images/logo-dark.svg';

  // If we have a dynamic logo URL, use it
  if (logoUrl && logoUrl.trim() !== '') {
    return (
      <h1 id="logo">
        <div className="logo-content">
          <img
            src={logoUrl}
            alt={platformName}
            className="logo-dynamic"
            style={{ height: '74px', width: 'auto' }}
          />
          <p
            style={{
              flexShrink: 0,
              width: 'auto',
              height: 'auto',
              whiteSpace: 'pre',
              position: 'relative',
              fontSize: 16,
              letterSpacing: 0,
              lineHeight: 1.2,
              textAlign: 'center',
              margin: 0,
            }}
          >
            {platformName}
          </p>
        </div>
      </h1>
    );
  }

  // Fallback: default SVG logo with theme support
  return (
    <h1 id="logo">
      <div className="logo-content">
        <img
          className="logo-desktop"
          src={logoSrc}
          alt="Davensi"
          width={64}
          height={74}
          style={{ objectFit: 'contain' }}
        />
        <img
          className="logo-tablet"
          src={logoSrc}
          alt="Davensi"
          width={50}
          height={56}
          style={{ objectFit: 'contain' }}
        />
        <p
          style={{
            flexShrink: 0,
            width: 'auto',
            height: 'auto',
            whiteSpace: 'pre',
            position: 'relative',
            fontSize: 16,
            letterSpacing: 0,
            lineHeight: 1.2,
            textAlign: 'center',
            margin: 0,
          }}
        >
          {platformName}
        </p>
      </div>
    </h1>
  );
}
